import Logger from 'components/Common/Logger';
import http from 'utils/http';
import { call, put } from 'redux-saga/effects';
import {
  fetchFlowNodesCompleteDetailsError,
  fetchFlowNodesCompleteDetailsSuccess,
} from 'redux/actions/FlowAction';
import { showAlert } from 'redux/actions/AlertActions';


export function* fetchFlowNodesCompleteDetails({ url, payload }) {
  const { error, nodes } = yield call(http.get, url);

  if (error) {
    Logger.error(error, `Could not fetch flow nodes complete details. Url: ${url}. Error: ${error}`);
    yield put(showAlert({ message: error, type: 'error' }));
    return yield put(fetchFlowNodesCompleteDetailsError(payload));
  }

  // Transform the data to match UI needs (an object for fast lookup in the flow reducer)
  const transformedNodesMap = (nodes ?? []).reduce((acc, nodeData) => (
    {
      ...acc,
      [nodeData.node.ID]: nodeData,
    }
  ), {});

  return yield put(fetchFlowNodesCompleteDetailsSuccess({
    nodesCompleteDetailsMap: transformedNodesMap,
  }));
}
